export const lightTheme = {
  main: "#FEFFFE",
  secondary: "#F5F5F5",
  contrast: "black",
  lighterContrast: "#505354",
};

export const darkTheme = {
  main: "#2B2F39",
  secondary: "#131623",
  contrast: "whitesmoke",
  lighterContrast: "#cccccc",
};
